
import { supabase } from '@/lib/supabase';
import { PropBot } from '@/types/prop-bots';

export const fetchPropBots = async (userId: string | undefined) => {
  try {
    // Fetch bots with prop details (only active bots)
    const { data: bots, error } = await supabase
      .from('bots')
      .select(`
        *,
        propDetails:bot_prop_details(*)
      `)
      .eq('type', 'prop_bot')
      .eq('status', 'active')
      .order('created_date', { ascending: false });

    if (error) throw error;

    // If we have a userId, fetch bot_accounts to check which bots are integrated
    if (userId) {
      const botIds = bots?.map(bot => bot.id) || [];
      
      if (botIds.length > 0) {
        // Check for accounts where either bot_id or original_bot_id matches any of the prop bot IDs
        const { data: botAccounts } = await supabase
          .from('bot_accounts')
          .select('bot_id, original_bot_id')
          .eq('user_id', userId)
          .or(`bot_id.in.(${botIds.join(',')}),original_bot_id.in.(${botIds.join(',')})`);

        // Create a set of bot IDs that are integrated (check both bot_id and original_bot_id)
        const integratedBotIds = new Set();
        botAccounts?.forEach(account => {
          // If bot_id matches a prop bot, mark it as integrated
          if (botIds.includes(account.bot_id)) {
            integratedBotIds.add(account.bot_id);
          }
          // If original_bot_id matches a prop bot, mark it as integrated
          if (account.original_bot_id && botIds.includes(account.original_bot_id)) {
            integratedBotIds.add(account.original_bot_id);
          }
        });

        return bots.map((bot: PropBot) => ({
          ...bot,
          is_integrated: integratedBotIds.has(bot.id)
        }));
      }
    }

    return bots;
  } catch (error) {
    console.error('Error fetching prop bots:', error);
    throw error;
  }
};
